import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type LcscV3LocaleCurrencyDTO = z.infer<typeof LcscV3LocaleCurrencyDTORuntype>;
export const LcscV3LocaleCurrencyDTORuntype = z.enum(['EUR', 'USD', 'HKD', 'CNY', 'CNYNoTax']);

export interface LcscV3CredentialsDTO extends z.infer<typeof LcscV3CredentialsDTORuntype> {}
export const LcscV3CredentialsDTORuntype = z.object({
    api_key: z.string(),
    api_secret: z.string(),
    currency: LcscV3LocaleCurrencyDTORuntype,
});

export interface LcscV3CredentialsInputDTO extends z.infer<typeof LcscV3CredentialsInputDTORuntype> {}
export const LcscV3CredentialsInputDTORuntype = z.object({
    api_key: z.string().optional(),
    api_secret: z.string().optional(),
    currency: LcscV3LocaleCurrencyDTORuntype.optional(),
});

export interface LcscV3ResponseBodyDTO extends z.infer<typeof LcscV3ResponseBodyDTORuntype> {}
export const LcscV3ResponseBodyDTORuntype = z.object({
    data: LcscV3CredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
